import { Link } from "react-scroll";

const Hero = () => {
    return (
        <section id="home" className="hero">
            <div className="hero-content">
                <h1>Scalable Software QA and Test Automation Services</h1>
                <p style={{fontSize:'larger'}}>Here To Help You Test Early</p>
                <Link to="contact" smooth={true} duration={500} offset={-70}>
                    <button className="cta-btn">Get in Touch</button>
                </Link>
            </div>
        </section>
    );
};

export default Hero;
